import script from "./valueProposition.vue?vue&type=script&setup=true&lang=js"
export * from "./valueProposition.vue?vue&type=script&setup=true&lang=js"

import "./valueProposition.vue?vue&type=style&index=0&id=61b85e14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b85e14"]])

export default __exports__